import { IMockCallMap } from '@modules/core';

export const findMockData = (
  url: string,
  method: string,
  map: IMockCallMap[]
) => {
  return (
    map.find((entry) => entry.path.test(url) && entry.method === method)
      ?.response || undefined
  );
};
